/**
 * Centrale versie van de applicatie. Bump deze bij elke release met nieuwe features.
 * Formaat: YYYY.MM.DD (eenvoudig te vergelijken als string).
 */
export const APP_VERSION = '2026.02.27';

/**
 * Release-notes per versie. Gebruikt door WhatsNewBanner om te tonen wat nieuw is.
 * Elke entry: { versie, datum, titel, samenvatting, feature_keys }
 * - feature_keys moet overeenkomen met keys uit /app/frontend/src/lib/features.js
 */
export const CHANGELOG = [
  {
    versie: '2026.02.27',
    datum: '27 februari 2026',
    titel: 'Verzend-controle & cascade-sync',
    samenvatting: 'Afgeleide documenten (bv. factuur uit leverbon) tonen automatisch een "Verzend-controle"-paneel met verschillen t.o.v. de bron. 1 klik om bij te werken, "Gecontroleerd"-stempel vóór verzending, cascade-bevestiging bij bronwijziging.',
    feature_keys: ['verzend_controle'],
  },
  {
    versie: '2026.02.26',
    datum: '26 februari 2026',
    titel: 'Nummering-harmonisatie tool',
    samenvatting: 'Nieuwe tool in Instellingen → Databeheer om documentnummers te harmoniseren naar het huidige padding-formaat (bv. FAC-2026-001 → FAC-2026-0001), inclusief bijwerken van cross-references en duplicaat-detectie.',
    feature_keys: ['nummering_harmonisatie'],
  },
  {
    versie: '2026.02.25',
    datum: '25 februari 2026',
    titel: 'Documentenstroom + Digitale handtekening op leverbon',
    samenvatting: 'Elke factuur / offerte / bestelbon / leverbon krijgt directe omzetknoppen én een sidebar met de volledige documentenketen. Klant kan leverbon ondertekenen op uw tablet of via 48u-geldige smartphone-link.',
    feature_keys: ['doc_stroom_conversie', 'leverbon_handtekening'],
  },
  {
    versie: '2026.02.24',
    datum: '24 februari 2026',
    titel: 'Kassaticket personaliseren',
    samenvatting: 'Ticket-nummering (prefix, cijfers, reset per dag), logo bovenaan (klein/medium/groot), header, voetekst en verkoopvoorwaarden bewerkbaar in Instellingen → Kassa → Kassaticket, met live-preview.',
    feature_keys: ['kassa_ticket_branding'],
  },
  {
    versie: '2026.02.23',
    datum: '23 februari 2026',
    titel: 'Touchscreen-kassa',
    samenvatting: 'Kassa is volledig herontworpen voor tablet/touchscreen: grote artikel-tegels, snel-bedrag-knoppen (€5/10/20/50/100/200), betaalwijze-tiles met inline bedrag-inputs en 64px-afrekenknop.',
    feature_keys: ['kassa_touch_ui'],
  },
  {
    versie: '2026.02.22',
    datum: '22 februari 2026',
    titel: 'Klant-display branding & reclame',
    samenvatting: 'Personaliseer het klant-display: welkom- en bedanktekst, kleurschema (6 voorinstellingen), roterende reclamebanners in idle-modus. Upload uw promo-afbeeldingen rechtstreeks in Instellingen → Kassa → Klant-display.',
    feature_keys: ['kassa_display_branding'],
  },
  {
    versie: '2026.02.21',
    datum: '21 februari 2026',
    titel: 'Klant-display — 2e scherm aan de kassa',
    samenvatting: 'Koppel een tablet of 2e monitor als klant-display: live artikels, totaal en een SEPA-betaal-QR die klanten kunnen scannen met hun bankapp.',
    feature_keys: ['kassa_klant_display'],
  },
  {
    versie: '2026.02.20',
    datum: '20 februari 2026',
    titel: 'Kassa & POS — split payments, Z-rapport en dag-naar-factuur',
    samenvatting: 'Volledige kassa-loop: gesplitste betalingen (contant/bancontact/visa/maestro), verplichte dagafsluiting met winstmarge voor admins, en één-klik conversie van dagomzet naar factuur.',
    feature_keys: [
      'kassa_split_payment',
      'kassa_z_rapport',
      'kassa_winst_admin',
      'kassa_dag_naar_factuur',
    ],
  },
  {
    versie: '2026.02.19',
    datum: '19 februari 2026',
    titel: 'Voorraad-POS-loop, barcodes en leverancier-automatisering',
    samenvatting: 'Van barcode-scanning tot automatische aankoopbestellingen met publieke bevestigingspagina — uw facturatie-app groeit uit tot een volwaardig voorraadsysteem.',
    feature_keys: [
      'ean_artikel',
      'ean_generator',
      'barcode_scanner',
      'labels_export',
      'voorraad_auto_sync',
      'voorraad_waarschuwing',
      'multi_leverancier',
      'po_aanmaken',
      'po_email_verzenden',
      'po_publiek_bevestig',
      'onboarding_wizard',
      'whats_new_banner',
    ],
  },
  // Voeg nieuwe releases bovenaan toe
];

/**
 * Vind alle features die nieuw zijn t.o.v. de laatst-geziene versie.
 */
export function nieuweReleasesSinds(laatstGeziene) {
  if (!laatstGeziene) return CHANGELOG; // alles nieuw als user nog niks gezien heeft
  return CHANGELOG.filter(c => c.versie > laatstGeziene);
}
